import { LocalizedLanguageFormData } from '../common/localizedLanguage';
import { localizedStringToFormData } from '../common/localizedString';
import {
  MealItemCustomizationModel,
  MealItemCustomizationOptionModel,
} from './mealItemCustomizationModel';

export interface MealItemCustomizationFormData {
  customerInstructions: LocalizedLanguageFormData;
  internalNotes?: LocalizedLanguageFormData;
}

export interface MealItemCustomizationOptionFormData {
  id?: string;
  names: LocalizedLanguageFormData;
  price: number;
  isAvailable: boolean;
}

export const toMealItemCustomizationOptionFormData = (
  option: MealItemCustomizationOptionModel
): MealItemCustomizationOptionFormData => ({
  id: option.id,
  names: localizedStringToFormData(option.name),
  price: option.price,
  isAvailable: option.isAvailable,
});

export const toMealItemCustomizationFormData = (
  customization: MealItemCustomizationModel
): MealItemCustomizationFormData => ({
  customerInstructions: localizedStringToFormData(
    customization.customerInstruction
  ),
  ...(customization.internalNote
    ? { internalNotes: localizedStringToFormData(customization.internalNote) }
    : {}),
});
